import { cva } from 'class-variance-authority';

export const sidebarMenuButtonVariants = cva(
  'peer/menu-button ring-focus-ring pointer-fine:hover:text-content-primary active:text-content-primary data-[active=true]:text-content-primary data-[state=open]:pointer-fine:hover:text-content-primary pointer-fine:hover:bg-neutral-interaction-hover active:bg-neutral-interaction-pressed data-[active=true]:bg-neutral-interaction-selected data-[state=open]:pointer-fine:hover:bg-neutral-interaction-selected flex w-full items-center gap-2 overflow-hidden rounded-md p-2 text-left type-nav outline-none transition-[width,height,padding] focus-visible:ring-2 disabled:pointer-events-none disabled:opacity-50 group-has-data-[sidebar=menu-action]/menu-item:pr-8 aria-disabled:pointer-events-none aria-disabled:opacity-50 data-[active=true]:font-semibold group-data-[collapsible=icon]:size-7! group-data-[collapsible=icon]:p-1.5! [&>span:last-child]:truncate [&>svg]:size-4 [&>svg]:shrink-0 pointer-coarse:min-h-11',
  {
    variants: {
      variant: {
        default: 'pointer-fine:hover:text-content-primary pointer-fine:hover:bg-neutral-interaction-hover',
        outline:
          'pointer-fine:hover:text-content-primary pointer-fine:hover:bg-neutral-interaction-hover bg-surface-base shadow-[0_0_0_1px_var(--border-default)] pointer-fine:hover:shadow-[0_0_0_1px_var(--neutral-interaction-hover)]',
      },
      size: {
        default: 'h-8',
        sm: 'h-7',
        lg: 'h-12 group-data-[collapsible=icon]:h-auto! group-data-[collapsible=icon]:p-0!',
      },
    },
    defaultVariants: {
      variant: 'default',
      size: 'default',
    },
  }
);

